import React, { useState, useEffect } from 'react';
import DataTable from 'react-data-table-component';
import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";
import { Link } from 'react-router-dom';

import { language } from '../WEBContent/Language';

import { getTokenInfo } from './../../UseToken';

import Loader from '../Loader/Loader';

import { 
    set_language,
    reqGET, 
    my_local_storage,
    //get_my_fact_company,
    get_fact_legacy_info,
    repo_icons_link,
} from '../../Utils';


import Hosts from '../../Hosts'

export default function View(props) {

    // const [, set_dados] = useState(null);
	//const list_purchase_orders = useRef(null);
	const [list_purchase_orders, set_list_purchase_orders] = useState([])
    const [list_equipments, set_list_equipments] = useState([])

    const [isloading, setLoading] = useState(true);
    const [isloadingEquipment, setLoadingEquipment] = useState(true);

    const [lang, set_lang] = useState('pt');
    //const [, set_lang_id] = useState('1');

    //const [n_testimony, set_n_testimony] = useState(0)
    const [classes_id, set_classes_id] = useState([])
    const [classes_n, set_classes_n] = useState([])

    const [order_classes_id, set_order_classes_id] = useState([])

    const [stats_day_n_order, set_stats_day_n_order] = useState(0)
    const [stats_day_t_order, set_stats_day_t_order] = useState(0.00)
    const [stats_last_n_order, set_stats_last_n_order] = useState(0)
    const [stats_last_t_order, set_stats_last_t_order] = useState(0.00)
    const [stats_month_n_order, set_stats_month_n_order] = useState(0)
    const [stats_month_t_order, set_stats_month_t_order] = useState(0.00)
    const [stats_year_n_order, set_stats_year_n_order] = useState(0)
    const [stats_year_t_order, set_stats_year_t_order] = useState(0.00)

    const [stats_total_n_order, set_stats_total_n_order] = useState(0)
    const [/*stats_total_t_order*/, set_stats_total_t_order] = useState(0.00)

    const [stats_day_n_entries, set_stats_day_n_entries] = useState(0)
    const [stats_last_n_entries, set_stats_last_n_entries] = useState(0)
    const [stats_month_n_entries, set_stats_month_n_entries] = useState(0)
    const [stats_year_n_entries, set_stats_year_n_entries] = useState(0)

    const [stats_day_new_users, set_stats_day_new_users] = useState(0)
    const [stats_last_new_users, set_stats_last_new_users] = useState(0)
    const [stats_month_new_users, set_stats_month_new_users] = useState(0)
    const [stats_year_new_users, set_stats_year_new_users] = useState(0)

    const [stats_day_new_users_app, set_stats_day_new_users_app] = useState(0)
    const [stats_last_new_users_app, set_stats_last_new_users_app] = useState(0)
    const [stats_month_new_users_app, set_stats_month_new_users_app] = useState(0)
    const [stats_year_new_users_app, set_stats_year_new_users_app] = useState(0)

    const [stats_day_new_users_web, set_stats_day_new_users_web] = useState(0)
    const [stats_last_new_users_web, set_stats_last_new_users_web] = useState(0)
    const [stats_month_new_users_web, set_stats_month_new_users_web] = useState(0)
    const [stats_year_new_users_web, set_stats_year_new_users_web] = useState(0)


    const [/*stats_total_new_users*/, set_stats_total_new_users] = useState(0)
    const [/*stats_total_new_users_app*/, set_stats_total_new_users_app] = useState(0)
    const [/*stats_total_new_users_web*/, set_stats_total_new_users_web] = useState(0)

    const [forfaits_not_used, set_forfaits_not_used] = useState(0)
    const [equipments_not_used, set_equipments_not_used] = useState(0)

    const [stats_day_new_order, set_stats_day_new_order] = useState(0)
    const [stats_last_new_order, set_stats_last_new_order] = useState(0)
    const [stats_month_new_order, set_stats_month_new_order] = useState(0)
    const [stats_year_new_order, set_stats_year_new_order] = useState(0)

    const [stats_day_new_order_used, set_stats_day_new_order_used] = useState(0)
    const [stats_last_new_order_used, set_stats_last_new_order_used] = useState(0)
    const [stats_month_new_order_used, set_stats_month_new_order_used] = useState(0)
    const [stats_year_new_order_used, set_stats_year_new_order_used] = useState(0)

    const [stats_day_new_order_notused, set_stats_day_new_order_notused] = useState(0)
    const [stats_last_new_order_notused, set_stats_last_new_order_notused] = useState(0)
    const [stats_month_new_order_notused, set_stats_month_new_order_notused] = useState(0)
    const [stats_year_new_order_notused, set_stats_year_new_order_notused] = useState(0)

    const [stats_total_n_order_used, set_stats_total_n_order_used] = useState(0)

    const [n_forfaits_day, set_n_forfaits_day] = useState(0)
    const [n_forfaits_last, set_n_forfaits_last] = useState(0)
    const [n_forfaits_month, set_n_forfaits_month] = useState(0)
    const [n_forfaits_year, set_n_forfaits_year] = useState(0)
    const [n_equipments_day, set_n_equipments_day] = useState(0)
    const [n_equipments_last, set_n_equipments_last] = useState(0)
    const [n_equipments_month, set_n_equipments_month] = useState(0)
    const [n_equipments_year, set_n_equipments_year] = useState(0)

    const [n_forfaits_total_day, set_n_forfaits_total_day] = useState(0)
    const [n_forfaits_total_last, set_n_forfaits_total_last] = useState(0)
    const [n_forfaits_total_month, set_n_forfaits_total_month] = useState(0)
    const [n_forfaits_total_year, set_n_forfaits_total_year] = useState(0)
    const [n_equipments_total_day, set_n_equipments_total_day] = useState(0)
    const [n_equipments_total_last, set_n_equipments_total_last] = useState(0)
    const [n_equipments_total_month, set_n_equipments_total_month] = useState(0)
    const [n_equipments_total_year, set_n_equipments_total_year] = useState(0)

    const [n_passe_se_total_day, set_n_passe_se_total_day] = useState(0)
    const [n_passe_se_total_last, set_n_passe_se_total_last] = useState(0)
    const [n_passe_se_total_month, set_n_passe_se_total_month] = useState(0)
    const [n_passe_se_total_year, set_n_passe_se_total_year] = useState(0)
    
    const [n_passe_ce_total_day, set_n_passe_ce_total_day] = useState(0)
    const [n_passe_ce_total_last, set_n_passe_ce_total_last] = useState(0)
    const [n_passe_ce_total_month, set_n_passe_ce_total_month] = useState(0)
    const [n_passe_ce_total_year, set_n_passe_ce_total_year] = useState(0)
    
    const [n_aluger_eq_total_day, set_n_aluger_eq_total_day] = useState(0)
    const [n_aluger_eq_total_last, set_n_aluger_eq_total_last] = useState(0)
    const [n_aluger_eq_total_month, set_n_aluger_eq_total_month] = useState(0)
    const [n_aluger_eq_total_year, set_n_aluger_eq_total_year] = useState(0)
    


    const change_lang = (l) => {
        set_language(l)
        set_lang(l)
        window.location.reload()

        //console.log('language', localStorage.getItem('lang'))
        //console.log('localstorage', localStorage)
    }

    useEffect(() => {

        //set_lang('pt')
        //set_lang_id('1')

        //get_fact_legacy_info()
        get_fact_legacy_info()

        if(localStorage.getItem('lang') === undefined  || localStorage.getItem('lang') === null || localStorage.getItem('lang') === '') {
            change_lang('pt')
        }
        else {
            set_lang(localStorage.getItem('lang'))
        }

        if(getTokenInfo().profile === 'Cliente') {

            reqGET(`${Hosts.SIMCore_API}/store/order/client/${Hosts.companycode}/${getTokenInfo().id}/aula`)
                .then(res => { 

                    let aux_aula = []
                    let aux_order_aula = []
                    let n_aulas_aux = 0
                    res.data.forEach(element => {
                        element.info.documento.linhas.forEach((el_l) => {

                            if(el_l.quantidade_aux_em_caso_de_aula !== undefined && parseInt(el_l.quantidade_aux_em_caso_de_aula) > 0) {
                                if(el_l.quantidade_aux_em_caso_de_aula !== undefined && el_l.quantidade_aux_em_caso_de_aula !== '') {
                                    n_aulas_aux += parseInt(el_l.quantidade_aux_em_caso_de_aula)
                                }
                                aux_aula.push(element)

                                let x = aux_order_aula.filter(el_aux => el_aux.id === element.id)
                                if(x.length === 0) {
                                    aux_order_aula.push(element)
                                }
                            }

                        })
                    });

                    set_order_classes_id(aux_order_aula)
                    set_classes_id(aux_aula)
                    set_classes_n(n_aulas_aux)
                    setLoading(false)

                })
                .catch(erro => console.log('Erro 2', erro))

        }
        else if(getTokenInfo().profile === 'Gestor de Conteúdos' || getTokenInfo().profile === 'Visualizador de Conteúdos' || getTokenInfo().profile === 'Administrador') {

            let today = new Date().toISOString().split('T')[0]
            let last = new Date().toISOString().split('T')[0]
            let month = new Date().toISOString().split('-')[0] + '-' + new Date().toISOString().split('-')[1]
            let year = new Date().toISOString().split('-')[0]


            let dia = today.split('-')[2]
            let mes = today.split('-')[1]

            last = 7

            reqGET(`${Hosts.SIMCore_API}/store/order/year/month/check/${Hosts.companycode}/${year}/${mes}`) 

            /*reqGET(`${Hosts.SIMCore_API}/web/content/type/${Hosts.companycode}/testimony`)
                .then(res => { 
                    set_n_testimony(res.data.length)
                })
                .catch(erro => console.log('Erro 1', erro))*/

            reqGET(`${Hosts.SIMCore_API}/store/order/stats/day/${Hosts.companycode}/${today}`)
                .then(res => { 
                    set_stats_day_n_order(res.data[0]['count'])
                    set_stats_day_t_order(res.data[0]['sum'])
                })
                .catch(erro => console.log('Erro 1', erro))

            reqGET(`${Hosts.SIMCore_API}/store/order/stats/last/${Hosts.companycode}/${last}`)
                .then(res => { 
                    set_stats_last_n_order(res.data[0]['count'])
                    set_stats_last_t_order(res.data[0]['sum'])
                })
                .catch(erro => console.log('Erro 1', erro))

            reqGET(`${Hosts.SIMCore_API}/store/order/stats/month/${Hosts.companycode}/${month}`)
                .then(res => { 
                    set_stats_month_n_order(res.data[0]['count'])
                    set_stats_month_t_order(res.data[0]['sum'])
                })
                .catch(erro => console.log('Erro 1', erro))

            reqGET(`${Hosts.SIMCore_API}/store/order/stats/year/${Hosts.companycode}/${year}`)
                .then(res => { 
                    set_stats_year_n_order(res.data[0]['count'])
                    set_stats_year_t_order(res.data[0]['sum'])
                })
                .catch(erro => console.log('Erro 1', erro))

            reqGET(`${Hosts.SIMCore_API}/store/order/stats/year/${Hosts.companycode}/*`)
                .then(res => { 
                    set_stats_total_n_order(res.data[0]['count'])
                    set_stats_total_t_order(res.data[0]['sum'])
                })
                .catch(erro => console.log('Erro 1', erro))


            reqGET(`${Hosts.SIMCore_API}/store/order/stats/day/used/${Hosts.companycode}/${today}`)
                .then(res => { 
                    set_stats_day_new_order_used(res.data[0]['count'])
                    // set_stats_day_t_order(res.data[0]['sum'])
                })
                .catch(erro => console.log('Erro 1', erro))

            reqGET(`${Hosts.SIMCore_API}/store/order/stats/last/used/${Hosts.companycode}/${last}`)
                .then(res => { 
                    set_stats_last_new_order_used(res.data[0]['count'])
                    // set_stats_last_t_order(res.data[0]['sum'])
                })
                .catch(erro => console.log('Erro 1', erro))

            reqGET(`${Hosts.SIMCore_API}/store/order/stats/month/used/${Hosts.companycode}/${month}`)
                .then(res => { 
                    set_stats_month_new_order_used(res.data[0]['count'])
                    // set_stats_month_t_order(res.data[0]['sum'])
                })
                .catch(erro => console.log('Erro 1', erro))

            reqGET(`${Hosts.SIMCore_API}/store/order/stats/year/used/${Hosts.companycode}/${year}`)
                .then(res => { 
                    set_stats_year_new_order_used(res.data[0]['count'])
                    // set_stats_year_t_order(res.data[0]['sum'])
                })
                .catch(erro => console.log('Erro 1', erro))

            reqGET(`${Hosts.SIMCore_API}/store/order/stats/year/used/${Hosts.companycode}/*`)
                .then(res => { 
                    set_stats_total_n_order_used(res.data[0]['count'])
                    // set_stats_total_t_order(res.data[0]['sum'])
                })
                .catch(erro => console.log('Erro 1', erro))


            reqGET(`${Hosts.SIMCore_API}/qr/history/stats/day/${Hosts.companycode}/entries/${today}`)
                .then(async res => { 

                    let n_aux = 0

                    let n_aux_ce = 0
                    let n_aux_se = 0

                    if(res.data !== undefined && res.data.length > 0) {
                        // res.data.forEach(el => {
                        for await(let el of res.data) {

                            if(el.info.entries !== undefined) {
                                // el.info.entries.forEach(el_e => {
                                for await(let el_e of el.info.entries) {

                                    // console.log('#####################')
                                    // console.log('el.info.entries', el_e)
                                    let uniqid_encomenda = el_e.id.replace('"', '').split('*')[7]
                                    let prod_n = parseInt(el_e.id.replace('"', '').split('*')[5]) + 1
                                    // console.log('uniqid_encomenda', uniqid_encomenda)
                                    console.log('prod_n', prod_n)

                                    // await  /store/order/payment/:companycode/:id
                                    let aux_enc = await reqGET(`${Hosts.SIMCore_API}/store/order/payment/${Hosts.companycode}/${uniqid_encomenda}`)
                                    // let aux_enc_prod_designacao = aux_enc.data[0].info.documento.linhas[prod_n].designacao
                                    // let aux_enc_prod_subname = aux_enc.data[0].info.documento.linhas[prod_n].subname
                                    // console.log('aux_enc.data[0].info.documento.linhas', aux_enc.data[0].info.documento.linhas)
                                    // console.log('aux_enc.data[0].info.documento.linhas[prod_n]', aux_enc.data[0].info.documento.linhas[prod_n])
                                    // console.log('aux_enc.data[0].info.documento.linhas[prod_n].designacao', aux_enc.data[0].info.documento.linhas[prod_n].designacao)
                                    // console.log('aux_enc_prod_designacao', aux_enc_prod_designacao)

                                    // if(aux_enc_prod_designacao.toLowerCase().includes('passe')) {
                                        console.log('######################')
                                        // console.log(aux_enc_prod_designacao)
                                    // }
                                    // else {
                                        console.log('$$$$$$$$$$$$$$$$$$$$$$')
                                        // console.log(aux_enc_prod_designacao)
                                    // }


                                    if(el_e.info.data.includes(today) /*&& el_e.status.toLowerCase() === 'em uso'*/) {
                                        n_aux++
                                    }

                                } 
                                // }) 
                            }
                            
                        }
                        // })

                        set_stats_day_n_entries(n_aux)

                    }


                })
                .catch(erro => console.log('Erro 1', erro))

            reqGET(`${Hosts.SIMCore_API}/qr/history/stats/last/${Hosts.companycode}/entries/${last}`)
                .then(res => { 

                    let today_last = new Date()
                    let today_last_1 = new Date()
                    let today_last_2 = new Date()
                    let today_last_3 = new Date()
                    let today_last_4 = new Date()
                    let today_last_5 = new Date()
                    let today_last_6 = new Date()

                    let data_6 = new Date(today_last_6.setDate(today_last_6.getDate() - 6))
                    let data_5 = new Date(today_last_5.setDate(today_last.getDate() - 5))
                    let data_4 = new Date(today_last_4.setDate(today_last_4.getDate() - 4))
                    let data_3 = new Date(today_last_3.setDate(today_last_3.getDate() - 3))
                    let data_2 = new Date(today_last_2.setDate(today_last_2.getDate() - 2))
                    let data_1 = new Date(today_last_1.setDate(today_last_1.getDate() - 1))
                    
                    let s_6 = data_6.toISOString().split('T')[0]
                    let s_5 = data_5.toISOString().split('T')[0]
                    let s_4 = data_4.toISOString().split('T')[0]
                    let s_3 = data_3.toISOString().split('T')[0]
                    let s_2 = data_2.toISOString().split('T')[0]
                    let s_1 = data_1.toISOString().split('T')[0]
                    let s_today = today_last.toISOString().split('T')[0]

                    let n_aux = 0
                    if(res.data !== undefined && res.data.length > 0) {
                        res.data.forEach(el => {

                            if(el.info.entries !== undefined) {
                                el.info.entries.forEach(el_e => {

                                    // console.log('el_e', el_e)
                                    if((el_e.info.data.includes(s_today) || el_e.info.data.includes(s_1) || el_e.info.data.includes(s_2) || el_e.info.data.includes(s_3) || el_e.info.data.includes(s_4) || el_e.info.data.includes(s_5) || el_e.info.data.includes(s_6)) /*&& el_e.info.status.toLowerCase() === 'em uso'*/) {
                                        n_aux++
                                    }

                                }) 
                            }
                            
                        })

                        set_stats_last_n_entries(n_aux)

                        // VERIFICAR DEPOIS 
                        // set_stats_month_n_entries(n_aux)

                    }


                })
                .catch(erro => console.log('Erro 1', erro))

            reqGET(`${Hosts.SIMCore_API}/qr/history/stats/month/${Hosts.companycode}/entries/${month}`)
                .then(res => { 

                    let n_aux = 0
                    if(res.data !== undefined && res.data.length > 0) {
                        res.data.forEach(el => {

                            if(el.info.entries !== undefined) {
                                el.info.entries.forEach(el_e => {

                                    if(el_e.info.data.includes(month) /*&& el_e.info.status.toLowerCase() === 'em uso'*/) {
                                        n_aux++
                                    }

                                }) 
                            }
                            
                        })

                        // VERIFICAR DEPOIS
                        set_stats_month_n_entries(n_aux)

                    }


                })
                .catch(erro => console.log('Erro 1', erro))

            reqGET(`${Hosts.SIMCore_API}/qr/history/stats/year/${Hosts.companycode}/entries/${year}`)
                .then(res => { 

                    let n_aux = 0
                    if(res.data !== undefined && res.data.length > 0) {
                        res.data.forEach(el => {

                            if(el.info.entries !== undefined) {
                                el.info.entries.forEach(el_e => {

                                    if(el_e.info.data.includes(year) /*&& el_e.info.status.toLowerCase() === 'em uso'*/) {
                                        n_aux++
                                    }

                                }) 
                            }
                            
                        })

                        set_stats_year_n_entries(n_aux)

                    }


                })
                .catch(erro => console.log('Erro 1', erro))

            reqGET(`${Hosts.SIMCore_API}/entities/history/stats/day/${Hosts.companycode}/Cliente/${today}`)
                .then(res => { 

                    set_stats_day_new_users(res.data[0]['count'])
                    set_stats_day_new_users_app(res.data[0]['app'])
                    set_stats_day_new_users_web(res.data[0]['web'])

                })
                .catch(erro => console.log('Erro 1', erro))

            reqGET(`${Hosts.SIMCore_API}/entities/history/stats/last/${Hosts.companycode}/Cliente/${last}`)
                .then(res => { 


                    set_stats_last_new_users(res.data[0]['count'])
                    set_stats_last_new_users_app(res.data[0]['app'])
                    set_stats_last_new_users_web(res.data[0]['web'])


                })
                .catch(erro => console.log('Erro 1', erro))

            reqGET(`${Hosts.SIMCore_API}/entities/history/stats/month/${Hosts.companycode}/Cliente/${month}`)
                .then(res => { 

                    
                    set_stats_month_new_users(res.data[0]['count'])
                    set_stats_month_new_users_app(res.data[0]['app'])
                    set_stats_month_new_users_web(res.data[0]['web'])


                })
                .catch(erro => console.log('Erro 1', erro))

            reqGET(`${Hosts.SIMCore_API}/entities/history/stats/year/${Hosts.companycode}/Cliente/${year}`)
                .then(res => { 

                    set_stats_year_new_users(res.data[0]['count'])
                    set_stats_year_new_users_app(res.data[0]['app'])
                    set_stats_year_new_users_web(res.data[0]['web'])


                })
                .catch(erro => console.log('Erro 1', erro))

            reqGET(`${Hosts.SIMCore_API}/entities/history/stats/year/${Hosts.companycode}/Cliente/*`)
                .then(res => { 

                    set_stats_total_new_users(res.data[0]['count'])
                    set_stats_total_new_users_app(res.data[0]['app'])
                    set_stats_total_new_users_web(res.data[0]['web'])


                })
                .catch(erro => console.log('Erro 1', erro))

            reqGET(`${Hosts.SIMCore_API}/store/order/limit/${Hosts.companycode}/150`)
                .then(res => { 

                    if(res.data !== undefined && res.data.length > 0) {


                        // VERIFICAR PICAGEM EFECTUADA 6905

                        set_list_purchase_orders(res.data)
                        //set_dados(list_purchase_orders.current = res.data)
                        
                        setLoading(false)

                    }

                })
                .catch(erro => console.log('Erro 1', erro))

            reqGET(`${Hosts.SIMCore_API}/store/order/year/month/day/notused/qrs/${Hosts.companycode}/*/*/*`)
                .then(res => { 

                    if(res.data !== undefined && res.data!== null) {

                        set_forfaits_not_used(res.data['forfaits'])
                        set_equipments_not_used(res.data['equipments'])
                        console.log('qrs', res.data)
                        
                        setLoading(false)

                    }

                })
                .catch(erro => console.log('Erro 1', erro))

            reqGET(`${Hosts.SIMCore_API}/store/order/year/month/day/paied/${Hosts.companycode}/${year}/${mes}/${dia}`)
                .then(async res => { 

                    let n_f = 0
                    let n_e = 0

                    if(res !== undefined && res !== null && res.data.length > 0) {
                        for await(let el of res.data) {
                            el.info.documento.linhas.forEach(el_l => {
                                if(el_l.designacao.toLowerCase().includes('forfait') || el_l.designacao.toLowerCase().includes('passe')) {
                                    if(el_l.subname.toLowerCase().includes('aluguer')) {
                                    }
                                    else {
                                        // console.log('el_l', el_l)
                                        // console.log('el_l.designacao', el_l.designacao)
                                        // console.log('el_l.quantidade', el_l.quantidade)

                                        if(el_l.designacao.toLowerCase().includes('fam')) {
                                            n_f = parseInt(n_f) + parseInt(parseInt(el_l.quantidade) * 4)
                                        }
                                        else {
                                            n_f = parseInt(n_f) + parseInt(el_l.quantidade)
                                        }
                                    }
                                }
                                if(el_l.designacao.toLowerCase().includes('equipamento') || el_l.designacao.toLowerCase().includes('eq.')) {
                                    if(el_l.subname.toLowerCase().includes('aluguer')) {
                                    }
                                    else {
                                        n_e = parseInt(n_e) + parseInt(el_l.quantidade)
                                    }
                                }
                                if(el_l.designacao.toLowerCase().includes('capacete')) {
                                    if(el_l.subname.toLowerCase().includes('aluguer')) {
                                    }
                                    else {
                                        n_e = parseInt(n_e) + parseInt(el_l.quantidade)
                                    }
                                }
                                if(el_l.designacao.toLowerCase().includes('botas')) {
                                    if(el_l.subname.toLowerCase().includes('aluguer')) {
                                    }
                                    else {
                                        n_e = parseInt(n_e) + parseInt(el_l.quantidade)
                                    }
                                }
                                if(el_l.designacao.toLowerCase().includes('skis')) {
                                    if(el_l.subname.toLowerCase().includes('aluguer')) {
                                    }
                                    else {
                                        n_e = parseInt(n_e) + parseInt(el_l.quantidade)
                                    }
                                }
                                if(el_l.designacao.toLowerCase().includes('bast')) {
                                    if(el_l.subname.toLowerCase().includes('aluguer')) {
                                    }
                                    else {
                                        n_e = parseInt(n_e) + parseInt(el_l.quantidade)
                                    }
                                }
                                if(el_l.designacao.toLowerCase().includes('prancha')) {
                                    if(el_l.subname.toLowerCase().includes('aluguer')) {
                                    }
                                    else {
                                        n_e = parseInt(n_e) + parseInt(el_l.quantidade)
                                    }
                                }
                            })
                        }

                        set_n_forfaits_total_day(n_f)
                        set_n_equipments_total_day(n_e)

                        // console.log('n_forfaits', n_forfaits)
                        // console.log('n_equipments', n_equipments)
                    }

                })
                .catch(erro => console.log('Erro 1', erro))

            reqGET(`${Hosts.SIMCore_API}/store/order/year/month/day/paied/${Hosts.companycode}/7`)
                .then(async res => { 

                    let n_f = 0
                    let n_e = 0

                    if(res !== undefined && res !== null && res.data.length > 0) {
                        for await(let el of res.data) {
                            el.info.documento.linhas.forEach(el_l => {
                                if(el_l.designacao.toLowerCase().includes('forfait') || el_l.designacao.toLowerCase().includes('passe')) {
                                    if(el_l.subname.toLowerCase().includes('aluguer')) {
                                    }
                                    else {
                
                                        // console.log('el_l', el_l)
                                        // console.log('el_l.designacao', el_l.designacao)
                                        // console.log('el_l.quantidade', el_l.quantidade)
                
                                        if(el_l.designacao.toLowerCase().includes('fam')) {
                                            n_f = parseInt(n_f) + parseInt(parseInt(el_l.quantidade) * 4)
                                        }
                                        else {
                                            n_f = parseInt(n_f) + parseInt(el_l.quantidade)
                                        }
                                    }
                                }
                                if(el_l.designacao.toLowerCase().includes('equipamento') || el_l.designacao.toLowerCase().includes('eq.')) {
                                    if(el_l.subname.toLowerCase().includes('aluguer')) {
                                    }
                                    else {
                                        n_e = parseInt(n_e) + parseInt(el_l.quantidade)
                                    }
                                }
                                if(el_l.designacao.toLowerCase().includes('capacete')) {
                                    if(el_l.subname.toLowerCase().includes('aluguer')) {
                                    }
                                    else {
                                        n_e = parseInt(n_e) + parseInt(el_l.quantidade)
                                    }
                                }
                                if(el_l.designacao.toLowerCase().includes('botas')) {
                                    if(el_l.subname.toLowerCase().includes('aluguer')) {
                                    }
                                    else {
                                        n_e = parseInt(n_e) + parseInt(el_l.quantidade)
                                    }
                                }
                                if(el_l.designacao.toLowerCase().includes('skis')) {
                                    if(el_l.subname.toLowerCase().includes('aluguer')) {
                                    }
                                    else {
                                        n_e = parseInt(n_e) + parseInt(el_l.quantidade)
                                    }
                                }
                                if(el_l.designacao.toLowerCase().includes('bast')) {
                                    if(el_l.subname.toLowerCase().includes('aluguer')) {
                                    }
                                    else {
                                        n_e = parseInt(n_e) + parseInt(el_l.quantidade)
                                    }
                                }
                                if(el_l.designacao.toLowerCase().includes('prancha')) {
                                    if(el_l.subname.toLowerCase().includes('aluguer')) {
                                    }
                                    else {
                                        n_e = parseInt(n_e) + parseInt(el_l.quantidade)
                                    }
                                }
                            })
                        }

                        set_n_forfaits_total_last(n_f)
                        set_n_equipments_total_last(n_e)

                        // console.log('n_forfaits', n_forfaits)
                        // console.log('n_equipments', n_equipments)
            
                    }

                })
                .catch(erro => console.log('Erro 1', erro))

            reqGET(`${Hosts.SIMCore_API}/store/order/year/month/day/paied/${Hosts.companycode}/${year}/${mes}/*`)
                .then(async res => { 

                    let n_f = 0
                    let n_e = 0

                    if(res !== undefined && res !== null && res.data.length > 0) {
                        for await(let el of res.data) {
                            el.info.documento.linhas.forEach(el_l => {
                                if(el_l.designacao.toLowerCase().includes('forfait') || el_l.designacao.toLowerCase().includes('passe')) {
                                    if(el_l.subname.toLowerCase().includes('aluguer')) {
                                    }
                                    else {
                                        // console.log('el_l', el_l)
                                        // console.log('el_l.designacao', el_l.designacao)
                                        // console.log('el_l.quantidade', el_l.quantidade)
                
                                        if(el_l.designacao.toLowerCase().includes('fam')) {
                                            n_f = parseInt(n_f) + parseInt(parseInt(el_l.quantidade) * 4)
                                        }
                                        else {
                                            n_f = parseInt(n_f) + parseInt(el_l.quantidade)
                                        }
                                    }
                                }
                                if(el_l.designacao.toLowerCase().includes('equipamento') || el_l.designacao.toLowerCase().includes('eq.')) {
                                    if(el_l.subname.toLowerCase().includes('aluguer')) {
                                    }
                                    else {
    	                                    n_e = parseInt(n_e) + parseInt(el_l.quantidade)
                                    }
                                }
                                if(el_l.designacao.toLowerCase().includes('capacete')) {
                                    if(el_l.subname.toLowerCase().includes('aluguer')) {
                                    }
                                    else {
                                        n_e = parseInt(n_e) + parseInt(el_l.quantidade)
                                    }
                                }
                                if(el_l.designacao.toLowerCase().includes('botas')) {
                                    if(el_l.subname.toLowerCase().includes('aluguer')) {
                                    }
                                    else {
                                        n_e = parseInt(n_e) + parseInt(el_l.quantidade)
                                    }
                                }
                                if(el_l.designacao.toLowerCase().includes('skis')) {
                                    if(el_l.subname.toLowerCase().includes('aluguer')) {
                                    }
                                    else {
                                        n_e = parseInt(n_e) + parseInt(el_l.quantidade)
                                    }
                                }
                                if(el_l.designacao.toLowerCase().includes('bast')) {
                                    if(el_l.subname.toLowerCase().includes('aluguer')) {
                                    }
                                    else {
                                        n_e = parseInt(n_e) + parseInt(el_l.quantidade)
                                    }
                                }
                                if(el_l.designacao.toLowerCase().includes('prancha')) {
                                    if(el_l.subname.toLowerCase().includes('aluguer')) {
                                    }
                                    else {
                                        n_e = parseInt(n_e) + parseInt(el_l.quantidade)
                                    }
                                }
                            })
                        }

                        set_n_forfaits_total_month(n_f)
                        set_n_equipments_total_month(n_e)

                        // console.log('n_forfaits', n_forfaits)
                        // console.log('n_equipments', n_equipments)
            
                    }

                })
                .catch(erro => console.log('Erro 1', erro))

            reqGET(`${Hosts.SIMCore_API}/store/order/year/month/day/paied/${Hosts.companycode}/${year}/*/*`)
                .then(async res => { 

                    let n_f = 0
                    let n_e = 0

                    if(res !== undefined && res !== null && res.data.length > 0) {
                        for await(let el of res.data) {
                            el.info.documento.linhas.forEach(el_l => {
                                if(el_l.designacao.toLowerCase().includes('forfait') || el_l.designacao.toLowerCase().includes('passe')) {
                                    if(el_l.subname.toLowerCase().includes('aluguer')) {
                                    }
                                    else {
                                        // console.log('el_l', el_l)
                                        // console.log('el_l.designacao', el_l.designacao)
                                        // console.log('el_l.quantidade', el_l.quantidade)
                
                                        if(el_l.designacao.toLowerCase().includes('fam')) {
                                            n_f = parseInt(n_f) + parseInt(parseInt(el_l.quantidade) * 4)
                                        }
                                        else {
                                            n_f = parseInt(n_f) + parseInt(el_l.quantidade)
                                        }
                                    }
                                }
                                if(el_l.designacao.toLowerCase().includes('equipamento') || el_l.designacao.toLowerCase().includes('eq.')) {
                                    if(el_l.subname.toLowerCase().includes('aluguer')) {
                                    }
                                    else {
                                        n_e = parseInt(n_e) + parseInt(el_l.quantidade)
                                    }
                                }
                                if(el_l.designacao.toLowerCase().includes('capacete')) {
                                    if(el_l.subname.toLowerCase().includes('aluguer')) {
                                    }
                                    else {
                                        n_e = parseInt(n_e) + parseInt(el_l.quantidade)
                                    }
                                }
                                if(el_l.designacao.toLowerCase().includes('botas')) {
                                    if(el_l.subname.toLowerCase().includes('aluguer')) {
                                    }
                                    else {
                                        n_e = parseInt(n_e) + parseInt(el_l.quantidade)
                                    }
                                }
                                if(el_l.designacao.toLowerCase().includes('skis')) {
                                    if(el_l.subname.toLowerCase().includes('aluguer')) {
                                    }
                                    else {
                                        n_e = parseInt(n_e) + parseInt(el_l.quantidade)
                                    }
                                }
                                if(el_l.designacao.toLowerCase().includes('bast')) {
                                    if(el_l.subname.toLowerCase().includes('aluguer')) {
                                    }
                                    else {
                                        n_e = parseInt(n_e) + parseInt(el_l.quantidade)
                                    }
                                }
                                if(el_l.designacao.toLowerCase().includes('prancha')) {
                                    if(el_l.subname.toLowerCase().includes('aluguer')) {
                                    }
                                    else {
                                        n_e = parseInt(n_e) + parseInt(el_l.quantidade)
                                    }
                                }
                            })
                        }

                        set_n_forfaits_total_year(n_f)
                        set_n_equipments_total_year(n_e)

                        // console.log('n_forfaits', n_forfaits)
                        // console.log('n_equipments', n_equipments)
            
                    }

                })
                .catch(erro => console.log('Erro 1', erro))
    


            reqGET(`${Hosts.SIMCore_API}/store/order/year/month/day/used/${Hosts.companycode}/${year}/${mes}/${dia}`)
                .then(async res => { 

                    let n_f = 0
                    let n_e = 0

                    let n_f_se = 0
                    let n_f_ce = 0

                    if(res !== undefined && res !== null && res.data.length > 0) {
                        for await(let el of res.data) {
                            el.info.documento.linhas.forEach(el_l => {
                                if(el_l.designacao.toLowerCase().includes('forfait') || el_l.designacao.toLowerCase().includes('passe') ) {
                                    if(el_l.subname.toLowerCase().includes('aluguer')) {
                                    }
                                    else {

                                        // console.log('################################')
                                        // console.log('el_l', el_l)
                                        // console.log('el_l.designacao', el_l.designacao)
                                        // console.log('el_l.quantidade', el_l.quantidade)
                
                                        if(el_l.designacao.toLowerCase().includes('fam')) {

                                            if(el_l.designacao.toLowerCase().includes('sem')) {
                                                n_f_se = parseInt(n_f_se) + parseInt(parseInt(el_l.quantidade) * 4)
                                            }
                                            else {
                                                n_f_ce = parseInt(n_f_ce) + parseInt(parseInt(el_l.quantidade) * 4)
                                            }

                                            n_f = parseInt(n_f) + parseInt(parseInt(el_l.quantidade) * 4)
                                        }
                                        else {

                                            if(el_l.designacao.toLowerCase().includes('sem')) {
                                                n_f_se = parseInt(n_f_se) + parseInt(parseInt(el_l.quantidade))
                                            }
                                            else {
                                                n_f_ce = parseInt(n_f_ce) + parseInt(parseInt(el_l.quantidade))
                                            }

                                            n_f = parseInt(n_f) + parseInt(el_l.quantidade)
                                        }

                                    }

                                }
                                if(el_l.designacao.toLowerCase().includes('equipamento') || el_l.designacao.toLowerCase().includes('eq.')) {

                                    if(el_l.subname.toLowerCase().includes('aluguer')) {
                                    }
                                    else {

                                        if(el_l.designacao.toLowerCase().includes('sem')) {
                                        }
                                        else {

                                            // console.log('$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$')
                                            // console.log('el_l', el_l)
                                            // console.log('el_l.designacao', el_l.designacao)
                                            // console.log('el_l.quantidade', el_l.quantidade)

                                            n_e = parseInt(n_e) + parseInt(el_l.quantidade)

                                        }
                                    }
                                }
                                if(el_l.designacao.toLowerCase().includes('capacete')) {
                                    if(el_l.subname.toLowerCase().includes('aluguer')) {
                                    }
                                    else {
                                        n_e = parseInt(n_e) + parseInt(el_l.quantidade)
                                    }
                                }
                                if(el_l.designacao.toLowerCase().includes('botas')) {
                                    if(el_l.subname.toLowerCase().includes('aluguer')) {
                                    }
                                    else {
                                        n_e = parseInt(n_e) + parseInt(el_l.quantidade)
                                    }
                                }
                                if(el_l.designacao.toLowerCase().includes('skis')) {
                                    if(el_l.subname.toLowerCase().includes('aluguer')) {
                                    }
                                    else {
                                        n_e = parseInt(n_e) + parseInt(el_l.quantidade)
                                    }
                                }
                                if(el_l.designacao.toLowerCase().includes('bast')) {
                                    if(el_l.subname.toLowerCase().includes('aluguer')) {
                                    }
                                    else {
                                        n_e = parseInt(n_e) + parseInt(el_l.quantidade)
                                    }
                                }
                                if(el_l.designacao.toLowerCase().includes('prancha')) {
                                    if(el_l.subname.toLowerCase().includes('aluguer')) {
                                    }
                                    else {
                                        n_e = parseInt(n_e) + parseInt(el_l.quantidade)
                                    }
                                }
                            })
                        }

                        set_n_forfaits_day(n_f)
                        set_n_equipments_day(n_e)

                        set_n_passe_ce_total_day(n_f_ce)
                        set_n_passe_se_total_day(n_f_se)

                        // console.log('n_forfaits', n_forfaits)
                        // console.log('n_equipments', n_equipments)
            
                    }

                })
                .catch(erro => console.log('Erro 1', erro))

            reqGET(`${Hosts.SIMCore_API}/store/order/year/month/day/used/${Hosts.companycode}/7`)
                .then(async res => { 

                    let n_f = 0
                    let n_e = 0

                    let n_f_se = 0
                    let n_f_ce = 0

                    if(res !== undefined && res !== null && res.data.length > 0) {
                        for await(let el of res.data) {
                            el.info.documento.linhas.forEach(el_l => {
                                if(el_l.designacao.toLowerCase().includes('forfait') || el_l.designacao.toLowerCase().includes('passe')) {
                                    if(el_l.subname.toLowerCase().includes('aluguer')) {
                                    }
                                    else {
                                        // console.log('el_l', el_l)
                                        // console.log('el_l.designacao', el_l.designacao)
                                        // console.log('el_l.quantidade', el_l.quantidade)
                
                                        if(el_l.designacao.toLowerCase().includes('fam')) {

                                            if(el_l.designacao.toLowerCase().includes('sem')) {
                                                n_f_se = parseInt(n_f_se) + parseInt(parseInt(el_l.quantidade) * 4)
                                            }
                                            else {
                                                n_f_ce = parseInt(n_f_ce) + parseInt(parseInt(el_l.quantidade) * 4)
                                            }

                                            n_f = parseInt(n_f) + parseInt(parseInt(el_l.quantidade) * 4)
                                        }
                                        else {
                                            
                                            if(el_l.designacao.toLowerCase().includes('sem')) {
                                                n_f_se = parseInt(n_f_se) + parseInt(parseInt(el_l.quantidade))
                                            }
                                            else {
                                                n_f_ce = parseInt(n_f_ce) + parseInt(parseInt(el_l.quantidade))
                                            }

                                            n_f = parseInt(n_f) + parseInt(el_l.quantidade)
                                        }
                                    }
                                }
                                if(el_l.designacao.toLowerCase().includes('equipamento') || el_l.designacao.toLowerCase().includes('eq.')) {
                                    if(el_l.subname.toLowerCase().includes('aluguer')) {
                                    }
                                    else {
                                        
                                        if(el_l.designacao.toLowerCase().includes('passe')) {
                                            n_f_ce = parseInt(n_f_ce) + parseInt(parseInt(el_l.quantidade))
                                        }

                                        n_e = parseInt(n_e) + parseInt(el_l.quantidade)
                                    }
                                }
                                if(el_l.designacao.toLowerCase().includes('capacete')) {
                                    if(el_l.subname.toLowerCase().includes('aluguer')) {
                                    }
                                    else {
                                        n_e = parseInt(n_e) + parseInt(el_l.quantidade)
                                    }
                                }
                                if(el_l.designacao.toLowerCase().includes('botas')) {
                                    if(el_l.subname.toLowerCase().includes('aluguer')) {
                                    }
                                    else {
                                        n_e = parseInt(n_e) + parseInt(el_l.quantidade)
                                    }
                                }
                                if(el_l.designacao.toLowerCase().includes('skis')) {
                                    if(el_l.subname.toLowerCase().includes('aluguer')) {
                                    }
                                    else {
                                        n_e = parseInt(n_e) + parseInt(el_l.quantidade)
                                    }
                                }
                                if(el_l.designacao.toLowerCase().includes('bast')) {
                                    if(el_l.subname.toLowerCase().includes('aluguer')) {
                                    }
                                    else {
                                        n_e = parseInt(n_e) + parseInt(el_l.quantidade)
                                    }
                                }
                                if(el_l.designacao.toLowerCase().includes('prancha')) {
                                    if(el_l.subname.toLowerCase().includes('aluguer')) {
                                    }
                                    else {
                                        n_e = parseInt(n_e) + parseInt(el_l.quantidade)
                                    }
                                }
                            })
                        }

                        set_n_forfaits_last(n_f)
                        set_n_equipments_last(n_e)

                        set_n_passe_ce_total_last(n_f_ce)
                        set_n_passe_se_total_last(n_f_se)

                        // console.log('n_forfaits', n_forfaits)
                        // console.log('n_equipments', n_equipments)
            
                    }

                })
                .catch(erro => console.log('Erro 1', erro))

            reqGET(`${Hosts.SIMCore_API}/store/order/year/month/day/used/${Hosts.companycode}/${year}/${mes}/*`)
                .then(async res => { 

                    let n_f = 0
                    let n_e = 0

                    let n_f_se = 0
                    let n_f_ce = 0

                    if(res !== undefined && res !== null && res.data.length > 0) {
                        for await(let el of res.data) {
                            el.info.documento.linhas.forEach(el_l => {
                                if(el_l.designacao.toLowerCase().includes('forfait') || el_l.designacao.toLowerCase().includes('passe')) {
                                    if(el_l.subname.toLowerCase().includes('aluguer')) {
                                    }
                                    else {
                                        // console.log('el_l', el_l)
                                        // console.log('el_l.designacao', el_l.designacao)
                                        // console.log('el_l.quantidade', el_l.quantidade)
                
                                        if(el_l.designacao.toLowerCase().includes('fam')) {
                                            
                                            if(el_l.designacao.toLowerCase().includes('sem')) {
                                                n_f_se = parseInt(n_f_se) + parseInt(parseInt(el_l.quantidade) * 4)
                                            }
                                            else {
                                                n_f_ce = parseInt(n_f_ce) + parseInt(parseInt(el_l.quantidade) * 4)
                                            }

                                            n_f = parseInt(n_f) + parseInt(parseInt(el_l.quantidade) * 4)
                                        }
                                        else {
                                            
                                            if(el_l.designacao.toLowerCase().includes('sem')) {
                                                n_f_se = parseInt(n_f_se) + parseInt(parseInt(el_l.quantidade))
                                            }
                                            else {
                                                n_f_ce = parseInt(n_f_ce) + parseInt(parseInt(el_l.quantidade))
                                            }

                                            n_f = parseInt(n_f) + parseInt(el_l.quantidade)
                                        }
                                    }
                                }
                                if(el_l.designacao.toLowerCase().includes('equipamento') || el_l.designacao.toLowerCase().includes('eq.')) {
                                    if(el_l.subname.toLowerCase().includes('aluguer')) {
                                    }
                                    else {
                                        
                                        if(el_l.designacao.toLowerCase().includes('passe')) {
                                            n_f_ce = parseInt(n_f_ce) + parseInt(parseInt(el_l.quantidade))
                                        }

                                        n_e = parseInt(n_e) + parseInt(el_l.quantidade)
                                    }
                                }
                                if(el_l.designacao.toLowerCase().includes('capacete')) {
                                    if(el_l.subname.toLowerCase().includes('aluguer')) {
                                    }
                                    else {
                                        n_e = parseInt(n_e) + parseInt(el_l.quantidade)
                                    }
                                }
                                if(el_l.designacao.toLowerCase().includes('botas')) {
                                    if(el_l.subname.toLowerCase().includes('aluguer')) {
                                    }
                                    else {
                                        n_e = parseInt(n_e) + parseInt(el_l.quantidade)
                                    }
                                }
                                if(el_l.designacao.toLowerCase().includes('skis')) {
                                    if(el_l.subname.toLowerCase().includes('aluguer')) {
                                    }
                                    else {
                                        n_e = parseInt(n_e) + parseInt(el_l.quantidade)
                                    }
                                }
                                if(el_l.designacao.toLowerCase().includes('bast')) {
                                    if(el_l.subname.toLowerCase().includes('aluguer')) {
                                    }
                                    else {
                                        n_e = parseInt(n_e) + parseInt(el_l.quantidade)
                                    }
                                }
                                if(el_l.designacao.toLowerCase().includes('prancha')) {
                                    if(el_l.subname.toLowerCase().includes('aluguer')) {
                                    }
                                    else {
                                        n_e = parseInt(n_e) + parseInt(el_l.quantidade)
                                    }
                                }
                            })
                        }

                        set_n_forfaits_month(n_f)
                        set_n_equipments_month(n_e)

                        set_n_passe_ce_total_month(n_f_ce)
                        set_n_passe_se_total_month(n_f_se)

                        // console.log('n_forfaits', n_forfaits)
                        // console.log('n_equipments', n_equipments)
            
                    }

                })
                .catch(erro => console.log('Erro 1', erro))

            reqGET(`${Hosts.SIMCore_API}/store/order/year/month/day/used/${Hosts.companycode}/${year}/*/*`)
                .then(async res => { 

                    let n_f = 0
                    let n_e = 0

                    let n_f_se = 0
                    let n_f_ce = 0

                    if(res !== undefined && res !== null && res.data.length > 0) {
                        for await(let el of res.data) {
                            el.info.documento.linhas.forEach(el_l => {
                                if(el_l.designacao.toLowerCase().includes('forfait') || el_l.designacao.toLowerCase().includes('passe')) {
                                    if(el_l.subname.toLowerCase().includes('aluguer')) {
                                    }
                                    else {
                                        // console.log('el_l', el_l)
                                        // console.log('el_l.designacao', el_l.designacao)
                                        // console.log('el_l.quantidade', el_l.quantidade)
                
                                        if(el_l.designacao.toLowerCase().includes('fam')) {

                                            if(el_l.designacao.toLowerCase().includes('sem')) {
                                                n_f_se = parseInt(n_f_se) + parseInt(parseInt(el_l.quantidade) * 4)
                                            }
                                            else {
                                                n_f_ce = parseInt(n_f_ce) + parseInt(parseInt(el_l.quantidade) * 4)
                                            }

                                            n_f = parseInt(n_f) + parseInt(parseInt(el_l.quantidade) * 4)
                                        }
                                        else {

                                            if(el_l.designacao.toLowerCase().includes('sem')) {
                                                n_f_se = parseInt(n_f_se) + parseInt(parseInt(el_l.quantidade))
                                            }
                                            else {
                                                n_f_ce = parseInt(n_f_ce) + parseInt(parseInt(el_l.quantidade))
                                            }

                                            n_f = parseInt(n_f) + parseInt(el_l.quantidade)
                                        }
                                    }
                                }
                                if(el_l.designacao.toLowerCase().includes('equipamento') || el_l.designacao.toLowerCase().includes('eq.')) {
                                    if(el_l.subname.toLowerCase().includes('aluguer')) {
                                    }
                                    else {

                                        if(el_l.designacao.toLowerCase().includes('passe')) {
                                            n_f_ce = parseInt(n_f_ce) + parseInt(parseInt(el_l.quantidade))
                                        }

                                        n_e = parseInt(n_e) + parseInt(el_l.quantidade)
                                    }
                                }
                                if(el_l.designacao.toLowerCase().includes('capacete')) {
                                    if(el_l.subname.toLowerCase().includes('aluguer')) {
                                    }
                                    else {
                                        n_e = parseInt(n_e) + parseInt(el_l.quantidade)
                                    }
                                }
                                if(el_l.designacao.toLowerCase().includes('botas')) {
                                    if(el_l.subname.toLowerCase().includes('aluguer')) {
                                    }
                                    else {
                                        n_e = parseInt(n_e) + parseInt(el_l.quantidade)
                                    }
                                }
                                if(el_l.designacao.toLowerCase().includes('skis')) {
                                    if(el_l.subname.toLowerCase().includes('aluguer')) {
                                    }
                                    else {
                                        n_e = parseInt(n_e) + parseInt(el_l.quantidade)
                                    }
                                }
                                if(el_l.designacao.toLowerCase().includes('bast')) {
                                    if(el_l.subname.toLowerCase().includes('aluguer')) {
                                    }
                                    else {
                                        n_e = parseInt(n_e) + parseInt(el_l.quantidade)
                                    }
                                }
                                if(el_l.designacao.toLowerCase().includes('prancha')) {
                                    if(el_l.subname.toLowerCase().includes('aluguer')) {
                                    }
                                    else {
                                        n_e = parseInt(n_e) + parseInt(el_l.quantidade)
                                    }
                                }
                            })
                        }

                        set_n_forfaits_year(n_f)
                        set_n_equipments_year(n_e)

                        set_n_passe_ce_total_year(n_f_ce)
                        set_n_passe_se_total_year(n_f_se)

                        // console.log('n_forfaits', n_forfaits)
                        // console.log('n_equipments', n_equipments)
            
                    }

                })
                .catch(erro => console.log('Erro 1', erro))



            /*
            // reqGET(`${Hosts.SIMCore_API}/qr/history/stats/day/${Hosts.companycode}/equipments/${today}`)
            // reqGET(`${Hosts.SIMCore_API}/qr/history/stats/month/${Hosts.companycode}/equipments/${month}`)
            reqGET(`${Hosts.SIMCore_API}/qr/history/stats/notdelivered/${Hosts.companycode}/equipments/${month}`)
                .then(async res => { 

                    if(res.data !== undefined && res.data.length > 0) {

                        let i = 0
                        let equipments_aux = []
                        for await(let el of res.data) {
                        // res.data.forEach(el => {

                            if(el.info.equipments !== undefined && el.info.equipments !== null && el.info.equipments.length > 0) {

                                if(el.info.equipments[el.info.equipments.length - 1].info.status.toLowerCase() !== 'entregue') {

                                    let aux_array = el.info.equipments[el.info.equipments.length - 1].id.split('*')

                                    let el_aux = {}
                                    // let id_payment = el.id.split('*')[el.id.split('*').length - 2]
                                    // let id_payment = el.info.equipments[el.info.equipments.length - 1].id_compra
                                    let id_payment = aux_array[7]

                                    // el_aux['id'] = ++i
                                    // el_aux['n_enc'] = el.info.id_encomenda
                                    // el_aux['data'] = el.info.equipments[el.info.equipments.length - 1].info.data.split('T')[0]
                                    // el_aux['hora'] = el.info.equipments[el.info.equipments.length - 1].info.data.split('T')[1].split(':')[0] + ':' + el.info.equipments[el.info.equipments.length - 1].info.data.split('T')[1].split(':')[1]
                                    // el_aux['name'] = el.info.documento.user_info.name

                                    // equipments_aux.push(el_aux)


                                    await reqGET(`${Hosts.SIMCore_API}/store/order/payment/${Hosts.companycode}/${id_payment}`)
                                        .then(res_2 => {

                                            if(res_2.data !== undefined && res_2.data.length > 0) {
                                                if(el.info.equipments[el.info.equipments.length - 1].info.data !== undefined && el.info.equipments[el.info.equipments.length - 1].info.data !== '') {

                                                    el_aux['id'] = ++i
                                                    el_aux['n_enc'] = res_2.data[0].id
                                                    el_aux['data'] = el.info.equipments[el.info.equipments.length - 1].info.data.split('T')[0]
                                                    el_aux['hora'] = el.info.equipments[el.info.equipments.length - 1].info.data.split('T')[1].split(':')[0] + ':' + el.info.equipments[el.info.equipments.length - 1].info.data.split('T')[1].split(':')[1]
                                                    el_aux['name'] = res_2.data[0].info.documento.user_info.name

                                                    equipments_aux.push(el_aux)

                                                }
                                            }

                                        })
                                        .catch(erro => console.log('Erro 1', erro))


                                }
                            }


                        // })
                        }

                        set_list_equipments(equipments_aux)

                    }


                })
                .catch(erro => console.log('Erro 1', erro))
            */


            /*
            reqGET(`${Hosts.SIMCore_API}/qr/history/stats/notdelivered2/${Hosts.companycode}/equipments/${month}`)
                .then(async res => { 

                    if(res.data !== undefined && res.data.length > 0) {

                        let i = 0
                        let equipments_aux = []
                        for await(let el of res.data) {
                        // res.data.forEach(el => {

                            if(el.equipments !== undefined && el.equipments !== null && el.equipments.length > 0) {


                                // console.log('el', el)

                                if(el.equipments[el.equipments.length - 1].info.status.toLowerCase() !== 'entregue') {

                                    // let aux_array = el.equipments[el.equipments.length - 1].id.split('*')

                                    let el_aux = {}
                                    // let id_payment = el.id.split('*')[el.id.split('*').length - 2]
                                    // let id_payment = el.equipments[el.equipments.length - 1].id_compra
                                    // let id_payment = aux_array[7]

                                    el_aux['id'] = ++i
                                    el_aux['n_enc'] = el.id_encomenda
                                    el_aux['data'] = el.equipments[el.equipments.length - 1].info.data.split('T')[0]
                                    el_aux['hora'] = el.equipments[el.equipments.length - 1].info.data.split('T')[1].split(':')[0] + ':' + el.equipments[el.equipments.length - 1].info.data.split('T')[1].split(':')[1]
                                    el_aux['name'] = el.documento.user_info.name

                                    equipments_aux.push(el_aux)

                                }
                            }


                        // })
                        }

                        // console.log('list_equipments', list_equipments)
                        // console.log('equipments_aux', equipments_aux)
                        set_list_equipments(equipments_aux)
                        setLoadingEquipment(false)

                    }


                })
                .catch(erro => console.log('Erro 1', erro))
            */
        }
        else if(getTokenInfo().profile === 'Colaborador' || getTokenInfo().profile === 'Instrutor') {

            reqGET(`${Hosts.SIMCore_API}/store/order/limit/${Hosts.companycode}/150`)
                .then(res => { 

                    if(res.data !== undefined && res.data.length > 0) {

                        set_list_purchase_orders(res.data)
                        //set_dados(list_purchase_orders.current = res.data)
                        
                        setLoading(false)

                    }

                })
                .catch(erro => console.log('Erro 1', erro))

        }
        else {

            setLoading(false)

        }

        /*if(getTokenInfo().profile === 'Instrutor') {

            let link_voltar = {
                pathname: '/instrutor_scale',
                state: { 
                    item: {
                        id: getTokenInfo().id
                    }, 
                    operation: 'edit' 
                }
            }

            // props.history.push(link_voltar)
            // props.history.push()
        }*/

    }, [props])

    const defaultComponentOptions = {
        rowsPerPageText: language[lang].table_rows_per_page,
        rangeSeparatorText: language[lang].table_separator,
        noRowsPerPage: false,
        selectAllRowsItem: false,
        selectAllRowsItemText: language[lang].table_all,
    }

    const columns_po = [
        {
            name: language[lang].field_n_encomenda,
            selector: 'id',
            sortable: true,
            center: true,
            minWidth: '100px',
            maxWidth: '10%',
        },
        {
            name: language[lang].field_date,
            selector: 'info.data',
            sortable: true,
            center: true,
            minWidth: '100px',
            maxWidth: '10%',
        },
        {
            name: language[lang].field_name,
            selector: 'info.documento.user_info.name',
            sortable: true,
            left: true,
            minWidth: '200px',
            maxWidth: '30%',
        },
        {
            name: language[lang].field_email,
            selector: 'info.documento.user_info.username',
            sortable: true,
            left: true,
            minWidth: '200px',
            maxWidth: '30%',
        },
        {
            name: language[lang].field_total,
            selector: 'info.documento.total_documento',
            cell: row => 
                <span style={{fontFamily: 'Open Sans, sans-serif', fontVariantNumeric: "tabular-nums"}}>
                    {parseFloat(row.info.documento.total_documento).toFixed(2) + ' €'}
                </span>
            ,
            sortable: true,
            right: true,
            minWidth: '100px',
            maxWidth: '10%',
        },
        {
            name: language[lang].field_tem_aula,
            selector: 'info.tem_aulas',
            cell: row => (
                row.info.tem_aulas === true ? 
                    <span className="badge rounded-0 bg-success"><i className="bi bi-check-lg text-white fs-4"></i> </span>
                : 
                   <span className="badge rounded-0 bg-danger"><i className="bi bi-x-lg text-white fs-4"></i></span>
            ),
            sortable: false,
            center: true,
            minWidth: '100px',
            maxWidth: '10%',
        },
        {
            name: language[lang].field_pagamento_pendente,
            selector: 'info.pagamento_pendente',
            cell: row => (
                parseInt(row.info.pagamento_pendente) === 1 ? 
                    <span className="badge rounded-0 bg-success"><i className="bi bi-check-lg text-white fs-4"></i></span> 
                : 
                    parseInt(row.info.pagamento_pendente) === 2 ? 
                            <span className="badge rounded-0 bg-primary"><i className="bi bi-check-lg text-white fs-4"></i></span> 
                        : 
                            parseInt(row.info.pagamento_pendente) === 3 ? 
                                <span className="badge rounded-0" style={{backgrounColor: '#7952b3;'}}><i className="bi bi-check-lg text-white fs-4"></i></span> 
                            : 
                                parseInt(row.info.pagamento_pendente) === 0 ? 
                                    <span className="badge rounded-0 bg-warning"><i className="bi bi-exclamation-lg text-dark fs-4"></i></span> 
                                : 
                                    parseInt(row.info.pagamento_pendente) === -2 ? 
                                        <span className="badge rounded-0 bg-secondary"><i className="bi bi-arrow-return-left text-white fs-4"></i></span>
                                    :
                                        <span className="badge rounded-0 bg-danger"><i className="bi bi-x-lg text-white fs-4"></i></span>
            ),
            sortable: false,
            center: true,
            minWidth: '100px',
            maxWidth: '10%',
        },
        {
            name: 'Plataforma',
            selector: 'info.origin',
            sortable: true,
            center: true,
            minWidth: '100px',
            maxWidth: '10%',
        },
        {
            name: '',
            right: true,
            export: false,
            print: false,
            minWidth: '75px',
            maxWidth: '10%',
            cell: row => 
                <span>
                    {
                    <Link className="button button-update button-view" to={{ pathname: 'store_order', state: { item: row, operation: 'view' } }} replace>
                        <i className="bi bi-eye"></i>
                    </Link>
                    }
                </span>
        },
    ]

    const columns_po_colaboradores = [
        {
            name: language[lang].field_n_encomenda,
            selector: 'id',
            sortable: true,
            left: true,
            minWidth: '100px',
            maxWidth: '10%',
        },
        {
            name: language[lang].field_date,
            selector: 'info.data',
            sortable: true,
            center: true,
            minWidth: '100px',
            maxWidth: '10%',
        },
        {
            name: language[lang].field_name,
            selector: 'info.documento.user_info.name',
            sortable: true,
            left: true,
            minWidth: '200px',
            maxWidth: '30%',
        },
        {
            name: language[lang].field_tem_aula,
            selector: 'info.tem_aulas',
            cell: row => (
                row.info.tem_aulas === true ? 
                    <span className="badge rounded-0 bg-success"><i className="bi bi-check-lg text-white fs-4"></i> </span>
                : 
                   <span className="badge rounded-0 bg-danger"><i className="bi bi-x-lg text-white fs-4"></i></span>
            ),
            sortable: false,
            center: true,
            minWidth: '100px',
            maxWidth: '10%',
        },
        {
            name: language[lang].field_pagamento_pendente,
            selector: 'info.pagamento_pendente',
            cell: row => (
                parseInt(row.info.pagamento_pendente) === 1 ? 
                    <span className="badge rounded-0 bg-success"><i className="bi bi-check-lg text-white fs-4"></i></span> 
                : 
                    parseInt(row.info.pagamento_pendente) === 2 ? 
                            <span className="badge rounded-0 bg-primary"><i className="bi bi-check-lg text-white fs-4"></i></span> 
                        : 
                            parseInt(row.info.pagamento_pendente) === 3 ? 
                                <span className="badge rounded-0" style={{backgrounColor: '#7952b3;'}}><i className="bi bi-check-lg text-white fs-4"></i></span> 
                            : 
                                parseInt(row.info.pagamento_pendente) === 0 ? 
                                    <span className="badge rounded-0 bg-warning"><i className="bi bi-exclamation-lg text-dark fs-4"></i></span> 
                                : 
                                    parseInt(row.info.pagamento_pendente) === -2 ? 
                                        <span className="badge rounded-0 bg-secondary"><i className="bi bi-arrow-return-left text-white fs-4"></i></span>
                                    :
                                        <span className="badge rounded-0 bg-danger"><i className="bi bi-x-lg text-white fs-4"></i></span>
            ),
            sortable: false,
            center: true,
            minWidth: '100px',
            maxWidth: '10%',
        },
        {
            name: 'Plataforma',
            selector: 'info.origin',
            sortable: true,
            center: true,
            minWidth: '100px',
            maxWidth: '10%',
        },
        {
            name: '',
            right: true,
            export: false,
            print: false,
            minWidth: '75px',
            maxWidth: '10%',
            cell: row => 
                <span>
                    {
                    <Link className="button button-update button-view" to={{ pathname: 'store_order', state: { item: row, operation: 'view' } }} replace>
                        <i className="bi bi-eye"></i>
                    </Link>
                    }
                </span>
        },
    ]

    const tableDataPO = {
        columns_po,
        list_purchase_orders,
        filterPlaceholder: language[lang].filter_placeholder,
        export: false,
        print: false
    }

    const columns_eq = [
        {
            name: 'Ocorrência',
            selector: 'id',
            sortable: true,
            center: true,
            minWidth: '150px',
            maxWidth: '10%',
        },
        {
            name: language[lang].field_n_encomenda,
            selector: 'n_enc',
            sortable: true,
            center: true,
            minWidth: '150px',
            maxWidth: '10%',
        },
        {
            name: language[lang].field_date,
            selector: 'data',
            sortable: true,
            center: true,
            minWidth: '150px',
            maxWidth: '10%',
        },
        {
            name: language[lang].field_name,
            selector: 'name',
            sortable: true,
            left: true,
            minWidth: '250px',
            maxWidth: '40%',
        },
        {
            name: language[lang].field_hora_levantamento,
            selector: 'hora',
            sortable: false,
            center: true,
            minWidth: '150px',
            maxWidth: '10%',
        },
        {
            name: language[lang].field_entrega,
            selector: '',
            cell: _ => (
                <span className="badge rounded-0 bg-danger">
                    <i className="bi bi-x-lg text-white fs-4"></i>
                </span>
            ),
            sortable: false,
            center: true,
            minWidth: '150px',
            maxWidth: '10%',
        },
        {
            name: '',
            right: true,
            export: false,
            print: false,
            minWidth: '150px',
            maxWidth: '10%',
            cell: row => 
                <span>
                    {
                    <Link className="button button-update button-view" to={{ pathname: 'store_order', state: { item: {id: row.n_enc}, operation: 'view' } }} replace>
                        <i className="bi bi-eye"></i>
                    </Link>
                    }
                </span>
        },
    ]

    /*const tableDataEQ = {
        columns_eq,
        list_equipments,
        filterPlaceholder: language[lang].filter_placeholder,
        export: false,
        print: false
    }*/

    return (isloading ?

        <Loader />

        :
            <main>
                {
                getTokenInfo().profile === 'Cliente' ?
                    <>
                        <div className={`dash-cards-2 header`}>
                            <h2 className="dash-title">{language[lang].dashboard}</h2>
                            <p>{language[lang].dashboard}</p>
                        </div>

                        <div className={`dash-cards-2 highlights`}>
                            <div className="card-single">
                                <div className="card-body">
                                    <Link to={{ pathname: '/client_regist', state: { item: {id: getTokenInfo().id}, operation: 'edit' } }} style={{ display: '' }} replace>
                                        <div className='d-flex justify-content-between align-items-center' >
                                            <div className='d-flex justify-content-between align-items-center' style={{height: '52px'}}>
                                                <i className="fs-1 ms-2 me-3 bi bi-person-badge"></i>
                                                <h5 className='mb-0'>Os meus dados</h5>
                                            </div>
                                            <div>
                                                <i className="fs-1 bi bi-arrow-right"></i>
                                            </div>
                                        </div>
                                    </Link>
                                </div>
                            </div>

                            <div className={(my_local_storage.getItem('snowCart') !== undefined && my_local_storage.getItem('snowCart') !== null) ? "card-single" : "d-none"}>
                                <div className="card-body">
                                    <a href={Hosts.WEB_SITE_URI + 'store/cart'} title="Carrinho" target="_blank" rel="noreferrer">
                                        <div className='d-flex justify-content-between align-items-center' >
                                            <div className='d-flex justify-content-between align-items-center' style={{height: '52px'}}>
                                                <i className="fs-1 ms-2 me-3 bi bi-cart4"></i>
                                                <h5 className='mb-0'>Carrinho</h5>
                                            </div>
                                            <div>
                                                <i className="fs-1 bi bi-arrow-right"></i>
                                            </div>
                                        </div>
                                    </a>
                                </div>
                            </div>

                            <div className="card-single">
                                <div className="card-body">
                                    <Link to={{ pathname: '/store_order_list', state: { item: {id: getTokenInfo().id}, operation: 'list' } }} style={{ display: '' }} replace>
                                        <div className='d-flex justify-content-between align-items-center' >
                                            <div className='d-flex justify-content-between align-items-center' style={{height: '52px'}}>
                                                <i className="fs-1 ms-2 me-3 bi bi-receipt"></i> 
                                                <h5 className='mb-0'>Encomendas</h5>
                                            </div>
                                            <div>
                                                <i className="fs-1 bi bi-arrow-right"></i>
                                            </div>
                                        </div>
                                    </Link>
                                </div>
                            </div>
                            <div className="card-single">
                                <div className="card-body">
                                    <a href={Hosts.WEB_SITE_URI} title={language[lang].web_page} target="_blank" rel="noreferrer">
                                        <div className='d-flex justify-content-between align-items-center' >
                                            <div className='d-flex justify-content-between align-items-center' style={{height: '52px'}}>
                                                <i className="fs-1 ms-2 me-3 bi bi-globe"></i>
                                                <h5 className='mb-0'>{language[lang].web_page}</h5>
                                            </div>
                                            <div>
                                                <i className="fs-1 bi bi-arrow-right"></i>
                                            </div>
                                        </div>
                                    </a>
                                </div>
                            </div>

                            {
                            classes_id.length > 0 && 0 ?
                                <div className="card-single">
                                    <div className="card-body">
                                        <a href={Hosts.WEB_SITE_URI + 'agendar/aula/' + classes_id[0].info.id_usado_para_gerar_pagamento} title="Marcar aula" target="_blank" rel="noreferrer">
                                            <div className='d-flex justify-content-between align-items-center' >
                                                <div className='d-flex justify-content-between align-items-center' style={{height: '52px'}}>
                                                    <i className="fs-1 ms-2 me-3 bi bi-calendar3"></i>
                                                    <h5 className='mb-0'>Marcar aula {classes_n > 0 ? '(' + classes_n +  ')' : ''}</h5>
                                                </div>
                                                <div>
                                                    <i className="fs-1 bi bi-arrow-right"></i>
                                                </div>
                                            </div>
                                        </a>
                                    </div>
                                </div>
                            :
                                null
                            }

                            {
                            classes_id.length > 0 && 0 ?
                                <div className="card-single">
                                    <div className="card-body">
                                        <Link className="" to={{ pathname: 'estancia_aula_schedule', state: { item: { id: classes_id[0].info.id_usado_para_gerar_pagamento }, operation: 'schedule' } }} style={{ display: '' }} replace>
                                            <div className='d-flex justify-content-between align-items-center' >
                                                <div className='d-flex justify-content-between align-items-center' style={{height: '52px'}}>
                                                    <i className="fs-1 ms-2 me-3 bi bi-calendar3"></i>
                                                    <h5 className='mb-0'>Marcar aula {classes_n > 0 ? '(' + classes_n +  ')' : ''}</h5>
                                                </div>
                                                <div>
                                                    <i className="fs-1 bi bi-arrow-right"></i>
                                                </div>
                                            </div>
                                        </Link>
                                    </div>
                                </div>
                            :
                                null
                            }

                            {
                            classes_id.length > 0 && 0 ?
                                <div className={`card-single`}>
                                    <div className="card-body">

                                        <div className='d-flex justify-content-between align-items-center' >
                                            <div className='d-flex justify-content-between align-items-center' style={{height: '52px'}}>
                                                <i className="fs-1 ms-2 me-3 bi bi-calendar3"></i>
                                                <h5 className='mb-0'>Marcar aula</h5>
                                            </div>
                                        </div>

                                        <div className="pb-10">
                                            <div className="div-table">
                                                <div className="table-body">

                                                    <table className='w-100'>
                                                        <thead>
                                                            <tr>
                                                                <th><strong>N.º Encomenda</strong></th>
                                                                <th><strong>Código</strong></th>
                                                                <th></th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                            classes_id.map((el, key) => {
                                                                return (
                                                                    <tr key={key}>
                                                                        <td>{el.id}</td>
                                                                        <td>{el.info.id_usado_para_gerar_pagamento}</td>
                                                                        <td>
                                                                            <Link className="" to={{ pathname: 'estancia_aula_schedule', state: { item: { id: el.info.id_usado_para_gerar_pagamento }, operation: 'schedule' } }} style={{ display: '' }} replace>
                                                                                <i className="fs-3 bi bi-arrow-right"></i>
                                                                            </Link>
                                                                        </td>
                                                                    </tr>
                                                                )
                                                            })
                                                            }
                                                        </tbody>
                                                    </table>

                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            :
                                null
                            }

                            {
                            order_classes_id.length > 0 ?
                                <div className={`card-single`}>
                                    <div className="card-body">

                                        <div className='d-flex justify-content-between align-items-center' >
                                            <div className='d-flex justify-content-between align-items-center' style={{height: '52px'}}>
                                                <i className="fs-1 ms-2 me-3 bi bi-calendar3"></i>
                                                <h5 className='mb-0'>Marcar aula</h5>
                                            </div>
                                        </div>

                                        <div className="pb-10">
                                            <div className="div-table">
                                                <div className="table-body">

                                                    <table className='w-100'>
                                                        <thead>
                                                            <tr>
                                                                <th><strong>N.º Encomenda</strong></th>
                                                                <th></th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                            order_classes_id.map((el, key) => {
                                                                return (
                                                                    <tr key={key}>
                                                                        <td>{el.id}</td>
                                                                        <td style={{textAlign: 'right'}}>
                                                                            <Link className="" to={{ pathname: 'store_order', state: { item: { id: el.id }, operation: 'view' } }} style={{ display: '' }} replace>
                                                                                <i className="fs-3 bi bi-arrow-right"></i>
                                                                            </Link>
                                                                        </td>
                                                                    </tr>
                                                                )
                                                            })
                                                            }
                                                        </tbody>
                                                    </table>

                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            :
                                null
                            }
                        </div>
                    </>
                :
                    null
                }

                {
                getTokenInfo().profile === 'Gestor de Conteúdos' || getTokenInfo().profile === 'Visualizador de Conteúdos' || getTokenInfo().profile === 'Administrador' ?
                    <>
                        <div className={`dash-cards-2 header`}>
                            <h2 className="dash-title">{language[lang].dashboard}</h2>
                            <p>{language[lang].dashboard}</p>
                        </div>

                        <div className={`dash-cards-2 highlights highlights-sm`}>
                            <div className={"card-single"}>
                                <div className="card-body">
                                    <div className='d-flex justify-content-between align-items-center' >
                                        <div className='d-flex justify-content-between align-items-center' style={{height: '52px'}}>
                                            <i className="fs-1 ms-2 me-3 bi bi-graph-up-arrow"></i>
                                        </div>
                                        <div className='text-end ms-2 me-3'>
                                            <h2 className='fs-3'>{stats_day_t_order !== undefined && stats_day_t_order !== null ? stats_day_t_order.toFixed(2) : '0.00' } €</h2>
                                            <h6>{language[lang].dash_stats_day}</h6>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className={"card-single"}>
                                <div className="card-body">
                                    <div className='d-flex justify-content-between align-items-center' >
                                        <div className='d-flex justify-content-between align-items-center' style={{height: '52px'}}>
                                            <i className="fs-1 ms-2 me-3 bi bi-graph-up-arrow"></i>
                                        </div>
                                        <div className='text-end ms-2 me-3'>
                                            <h2 className='fs-3'>{stats_last_t_order !== undefined && stats_last_t_order !== null ? stats_last_t_order.toFixed(2) : '0.00' } €</h2>
                                            <h6>{language[lang].dash_stats_last}</h6>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className={"card-single"}>
                                <div className="card-body">
                                    <div className='d-flex justify-content-between align-items-center' >
                                        <div className='d-flex justify-content-between align-items-center' style={{height: '52px'}}>
                                            <i className="fs-1 ms-2 me-3 bi bi-graph-up-arrow"></i>
                                        </div>
                                        <div className='text-end ms-2 me-3'>
                                            <h2 className='fs-3'>{stats_month_t_order !== undefined && stats_month_t_order !== null ? stats_month_t_order.toFixed(2) : '0.00' } €</h2>
                                            <h6>{language[lang].dash_stats_month}</h6>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className={"card-single"}>
                                <div className="card-body">
                                    <div className='d-flex justify-content-between align-items-center' >
                                        <div className='d-flex justify-content-between align-items-center' style={{height: '52px'}}>
                                            <i className="fs-1 ms-2 me-3 bi bi-graph-up-arrow"></i>
                                        </div>
                                        <div className='text-end ms-2 me-3'>
                                            <h2 className='fs-3'>{stats_year_t_order !== undefined && stats_year_t_order !== null ? stats_year_t_order.toFixed(2) : '0.00' } €</h2>
                                            <h6>{language[lang].dash_stats_year}</h6>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className={`dash-cards-2 highlights highlights-sm`}>
                            <div className={"card-single"}>
                                <div className="card-body">
                                    <div className='d-flex justify-content-between align-items-center' >
                                        <div className='d-flex justify-content-between align-items-center' style={{height: '52px'}}>
                                            <i className="fs-1 ms-2 me-3 bi bi-box-arrow-in-right"></i>
                                        </div>
                                        <div className='text-end ms-2 me-3'>
                                            <div className='d-flex justify-content-between align-items-center'>
                                                <h6 className="me-4">Entradas</h6>
                                                <h2 className='fs-3'>
                                                    {stats_day_n_entries !== undefined && stats_day_n_entries !== null ? stats_day_n_entries : '0' } 
                                                </h2>
                                            </div>
                                            <h6>{language[lang].dash_stats_day}</h6>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className={"card-single"}>
                                <div className="card-body">
                                    <div className='d-flex justify-content-between align-items-center' >
                                        <div className='d-flex justify-content-between align-items-center' style={{height: '52px'}}>
                                            <i className="fs-1 ms-2 me-3 bi bi-box-arrow-in-right"></i>
                                        </div>
                                        <div className='text-end ms-2 me-3'>
                                            <div className='d-flex justify-content-between align-items-center'>
                                                <h6 className="me-4">Entradas</h6>
                                                <h2 className='fs-3'>
                                                    {stats_last_n_entries !== undefined && stats_last_n_entries !== null ? stats_last_n_entries : '0' }
                                                </h2>
                                            </div>
                                            <h6>{language[lang].dash_stats_last}</h6>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className={"card-single"}>
                                <div className="card-body">
                                    <div className='d-flex justify-content-between align-items-center' >
                                        <div className='d-flex justify-content-between align-items-center' style={{height: '52px'}}>
                                            <i className="fs-1 ms-2 me-3 bi bi-box-arrow-in-right"></i>
                                        </div>
                                        <div className='text-end ms-2 me-3'>
                                            <div className='d-flex justify-content-between align-items-center'>
                                                <h6 className="me-4">Entradas</h6>
                                                <h2 className='fs-3'>
                                                    {stats_month_n_entries !== undefined && stats_month_n_entries !== null ? stats_month_n_entries : '0' }
                                                </h2>
                                            </div>
                                            <h6>{language[lang].dash_stats_month}</h6>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className={"card-single"}>
                                <div className="card-body">
                                    <div className='d-flex justify-content-between align-items-center' >
                                        <div className='d-flex justify-content-between align-items-center' style={{height: '52px'}}>
                                            <i className="fs-1 ms-2 me-3 bi bi-box-arrow-in-right"></i>
                                        </div>
                                        <div className='text-end ms-2 me-3'>
                                            <div className='d-flex justify-content-between align-items-center'>
                                                <h6 className="me-4">Entradas</h6>
                                                <h2 className='fs-3'>
                                                    {stats_year_n_entries !== undefined && stats_year_n_entries !== null ? stats_year_n_entries : '0' }
                                                </h2>
                                            </div>
                                            <h6>{language[lang].dash_stats_year}</h6>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>


                        <div className={`dash-cards-2 highlights highlights-sm`}>
                            <div className={"card-single"}>
                                <div className="card-body">
                                    <div className='d-flex justify-content-between align-items-center' >
                                        <div className='d-flex justify-content-between align-items-center' style={{height: '52px'}}>
                                            <i className="fs-1 ms-2 me-3 bi bi-person-plus"></i>
                                        </div>
                                        <div className='text-end ms-2 me-3'>
                                            <div className='d-flex justify-content-between align-items-center'>
                                                <h6 className="me-4">Registos</h6>
                                                <h2 className='fs-3'>
                                                    {stats_day_new_users !== undefined && stats_day_new_users !== null ? stats_day_new_users : '0' }
                                                </h2>
                                            </div>
                                            <h6>
                                                App: {stats_day_new_users_app !== undefined && stats_day_new_users_app !== null ? stats_day_new_users_app : '0' }
                                                &nbsp;&nbsp;
                                                Web: {stats_day_new_users_web !== undefined && stats_day_new_users_web !== null ? stats_day_new_users_web : '0' }
                                            </h6>
                                            <h6>{language[lang].dash_stats_day}</h6>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className={"card-single"}>
                                <div className="card-body">
                                    <div className='d-flex justify-content-between align-items-center' >
                                        <div className='d-flex justify-content-between align-items-center' style={{height: '52px'}}>
                                            <i className="fs-1 ms-2 me-3 bi bi-person-plus"></i>
                                        </div>
                                        <div className='text-end ms-2 me-3'>
                                            <div className='d-flex justify-content-between align-items-center'>
                                                <h6 className="me-4">Registos</h6>
                                                <h2 className='fs-3'>
                                                    {stats_last_new_users !== undefined && stats_last_new_users !== null ? stats_last_new_users : '0' }
                                                </h2>
                                            </div>
                                            <h6>
                                                App: {stats_last_new_users_app !== undefined && stats_last_new_users_app !== null ? stats_last_new_users_app : '0' }
                                                &nbsp;&nbsp;
                                                Web: {stats_last_new_users_web !== undefined && stats_last_new_users_web !== null ? stats_last_new_users_web : '0' }
                                            </h6>
                                            <h6>{language[lang].dash_stats_last}</h6>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className={"card-single"}>
                                <div className="card-body">
                                    <div className='d-flex justify-content-between align-items-center' >
                                        <div className='d-flex justify-content-between align-items-center' style={{height: '52px'}}>
                                            <i className="fs-1 ms-2 me-3 bi bi-person-plus"></i>
                                        </div>
                                        <div className='text-end ms-2 me-3'>
                                            <div className='d-flex justify-content-between align-items-center'>
                                                <h6 className="me-4">Registos</h6>
                                                <h2 className='fs-3'>
                                                    {stats_month_new_users !== undefined && stats_month_new_users !== null ? stats_month_new_users : '0' }
                                                </h2>
                                            </div>
                                            <h6>
                                                App: {stats_month_new_users_app !== undefined && stats_month_new_users_app !== null ? stats_month_new_users_app : '0' }
                                                &nbsp;&nbsp;
                                                Web: {stats_month_new_users_web !== undefined && stats_month_new_users_web !== null ? stats_month_new_users_web : '0' }
                                            </h6>
                                            <h6>{language[lang].dash_stats_month}</h6>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className={"card-single"}>
                                <div className="card-body">
                                    <div className='d-flex justify-content-between align-items-center' >
                                        <div className='d-flex justify-content-between align-items-center' style={{height: '52px'}}>
                                            <i className="fs-1 ms-2 me-3 bi bi-person-plus"></i>
                                        </div>
                                        <div className='text-end ms-2 me-3'>
                                            <div className='d-flex justify-content-between align-items-center'>
                                                <h6 className="me-4">Registos</h6>
                                                <h2 className='fs-3'>
                                                    {stats_year_new_users !== undefined && stats_year_new_users !== null ? stats_year_new_users : '0' }
                                                </h2>
                                            </div>
                                            <h6>
                                                App: {stats_year_new_users_app !== undefined && stats_year_new_users_app !== null ? stats_year_new_users_app : '0' }
                                                &nbsp;&nbsp;
                                                Web: {stats_year_new_users_web !== undefined && stats_year_new_users_web !== null ? stats_year_new_users_web : '0' }
                                            </h6>
                                            <h6>{language[lang].dash_stats_year}</h6>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className={`dash-cards-2 highlights`}>
                            <div className="card-single">
                                <div className="card-body">
                                    <div className='d-flex justify-content-between align-items-center' >
                                        <div className='d-flex justify-content-between align-items-center' style={{height: '52px'}}>
                                            <i className="fs-1 ms-2 me-3 bi bi-file-earmark" style={{color: '#83a1b2'}}></i>
                                        </div>
                                        <div className='text-end ms-2 me-3'>
                                            <h2 className='fs-3'>{ parseInt(stats_total_n_order) - parseInt(stats_total_n_order_used) }</h2>
                                            <h6>{language[lang].order_not_used}</h6>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="card-single">
                                <div className="card-body">
                                    <div className='d-flex justify-content-between align-items-center' >
                                        <div className='d-flex justify-content-between align-items-center' style={{height: '52px'}}>
                                            <img className="img-fluid" style={{maxHeight: '50px'}} alt='' src={repo_icons_link("icon-forfait.png")} />
                                        </div>
                                        <div className='text-end ms-2 me-3'>
                                            <h2 className='fs-3'>{forfaits_not_used !== undefined && forfaits_not_used !== null ? forfaits_not_used : '0' }</h2>
                                            <h6>{language[lang].forfaits_not_used}</h6>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="card-single">
                                <div className="card-body">
                                    <div className='d-flex justify-content-between align-items-center' >
                                        <div className='d-flex justify-content-between align-items-center' style={{height: '52px'}}>
                                        <img className="img-fluid" style={{maxHeight: '50px'}} alt='' src={repo_icons_link("icon-equipamento.png")} />
                                        </div>
                                        <div className='text-end ms-2 me-3'>
                                            <h2 className='fs-3'>{equipments_not_used !== undefined && equipments_not_used !== null ? equipments_not_used : '0' }</h2>
                                            <h6>{language[lang].equipments_not_used}</h6>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>

                        <div className={`dash-cards body`}>
                            <div className="container">
                                <div className="card mt-3">
                                    <div className="card-body py-0">
                                        <label className="col-form-label fw-bold fs-4">Informação geral</label>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className={`dash-cards-2 highlights highlights-sm`}>
                            <div className={"card-single"}>
                                <div className="card-body">
                                    <div className='d-flex justify-content-between align-items-center' >
                                        <div className='d-flex justify-content-between align-items-center' style={{height: '52px'}}>
                                            <i className="fs-1 ms-2 me-3 bi bi-file-earmark"></i>
                                        </div>
                                        <div className='text-end ms-2 me-3'>
                                            <div className='d-flex justify-content-between align-items-center'>
                                                <h6 className="me-4">Encomendas</h6>
                                                <h2 className='fs-3'>
                                                    {stats_day_n_order !== undefined && stats_day_n_order !== null ? stats_day_n_order : '0' }
                                                </h2>
                                            </div>
                                            <h6>
                                                Utilizadas: {stats_day_new_order_used !== undefined && stats_day_new_order_used !== null ? stats_day_new_order_used : '0' }
                                            </h6>
                                            <h6>{language[lang].dash_stats_day}</h6>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className={"card-single"}>
                                <div className="card-body">
                                    <div className='d-flex justify-content-between align-items-center' >
                                        <div className='d-flex justify-content-between align-items-center' style={{height: '52px'}}>
                                            <i className="fs-1 ms-2 me-3 bi bi-file-earmark"></i>
                                        </div>
                                        <div className='text-end ms-2 me-3'>
                                            <div className='d-flex justify-content-between align-items-center'>
                                                <h6 className="me-4">Encomendas</h6>
                                                <h2 className='fs-3'>
                                                    {stats_last_n_order !== undefined && stats_last_n_order !== null ? stats_last_n_order : '0' }
                                                </h2>
                                            </div>
                                            <h6>
                                                Utilizadas: {stats_last_new_order_used !== undefined && stats_last_new_order_used !== null ? stats_last_new_order_used : '0' }
                                            </h6>
                                            <h6>{language[lang].dash_stats_last}</h6>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className={"card-single"}>
                                <div className="card-body">
                                    <div className='d-flex justify-content-between align-items-center' >
                                        <div className='d-flex justify-content-between align-items-center' style={{height: '52px'}}>
                                            <i className="fs-1 ms-2 me-3 bi bi-file-earmark"></i>
                                        </div>
                                        <div className='text-end ms-2 me-3'>
                                            <div className='d-flex justify-content-between align-items-center'>
                                                <h6 className="me-4">Encomendas</h6>
                                                <h2 className='fs-3'>
                                                    {stats_month_n_order !== undefined && stats_month_n_order !== null ? stats_month_n_order : '0' }
                                                </h2>
                                            </div>
                                            <h6>
                                                Utilizadas: {stats_month_new_order_used !== undefined && stats_month_new_order_used !== null ? stats_month_new_order_used : '0' }
                                            </h6>
                                            <h6>{language[lang].dash_stats_month}</h6>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className={"card-single"}>
                                <div className="card-body">
                                    <div className='d-flex justify-content-between align-items-center' >
                                        <div className='d-flex justify-content-between align-items-center' style={{height: '52px'}}>
                                            <i className="fs-1 ms-2 me-3 bi bi-file-earmark"></i>
                                        </div>
                                        <div className='text-end ms-2 me-3'>
                                            <div className='d-flex justify-content-between align-items-center'>
                                                <h6 className="me-4">Encomendas</h6>
                                                <h2 className='fs-3'>
                                                    {stats_year_n_order !== undefined && stats_year_n_order !== null ? stats_year_n_order : '0' }
                                                </h2>
                                            </div>
                                            <h6>
                                                Utilizadas: {stats_year_new_order_used !== undefined && stats_year_new_order_used !== null ? stats_year_new_order_used : '0' }
                                            </h6>
                                            <h6>{language[lang].dash_stats_year}</h6>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className={`dash-cards-2 highlights highlights-sm`}>
                            <div className={"card-single"}>
                                <div className="card-body">
                                    <div className='d-flex justify-content-between align-items-center' >
                                        <div className='d-flex justify-content-between align-items-center' style={{height: '52px'}}>
                                            <img className="img-fluid" style={{maxHeight: '45px'}} alt='' src={repo_icons_link("icon-forfait.png")} />
                                        </div>
                                        <div className='text-end ms-2 me-3'>
                                            <div className='d-flex justify-content-between align-items-center'>
                                                <h6 className="me-4">Forfaits</h6>
                                                <h2 className='fs-3'>
                                                    {n_forfaits_total_day !== undefined && n_forfaits_total_day !== null ? n_forfaits_total_day : '0' }
                                                </h2>
                                            </div>
                                            <h6>
                                                Utilizados: {n_forfaits_day !== undefined && n_forfaits_day !== null ? n_forfaits_day : '0' }
                                            </h6>
                                            <h6>{language[lang].dash_stats_day}</h6>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className={"card-single"}>
                                <div className="card-body">
                                    <div className='d-flex justify-content-between align-items-center' >
                                        <div className='d-flex justify-content-between align-items-center' style={{height: '52px'}}>
                                            <img className="img-fluid" style={{maxHeight: '45px'}} alt='' src={repo_icons_link("icon-forfait.png")} />
                                        </div>
                                        <div className='text-end ms-2 me-3'>
                                            <div className='d-flex justify-content-between align-items-center'>
                                                <h6 className="me-4">Forfaits</h6>
                                                <h2 className='fs-3'>
                                                    {n_forfaits_total_last !== undefined && n_forfaits_total_last !== null ? n_forfaits_total_last : '0' }
                                                </h2>
                                            </div>
                                            <h6>
                                                Utilizados: {n_forfaits_last !== undefined && n_forfaits_last !== null ? n_forfaits_last : '0' }
                                            </h6>
                                            <h6>{language[lang].dash_stats_last}</h6>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className={"card-single"}>
                                <div className="card-body">
                                    <div className='d-flex justify-content-between align-items-center' >
                                        <div className='d-flex justify-content-between align-items-center' style={{height: '52px'}}>
                                            <img className="img-fluid" style={{maxHeight: '45px'}} alt='' src={repo_icons_link("icon-forfait.png")} />
                                        </div>
                                        <div className='text-end ms-2 me-3'>
                                            <div className='d-flex justify-content-between align-items-center'>
                                                <h6 className="me-4">Forfaits</h6>
                                                <h2 className='fs-3'>
                                                    {n_forfaits_total_month !== undefined && n_forfaits_total_month !== null ? n_forfaits_total_month : '0' }
                                                </h2>
                                            </div>
                                            <h6>
                                                Utilizados: {n_forfaits_month !== undefined && n_forfaits_month !== null ? n_forfaits_month : '0' }
                                            </h6>
                                            <h6>{language[lang].dash_stats_month}</h6>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className={"card-single"}>
                                <div className="card-body">
                                    <div className='d-flex justify-content-between align-items-center' >
                                        <div className='d-flex justify-content-between align-items-center' style={{height: '52px'}}>
                                            <img className="img-fluid" style={{maxHeight: '45px'}} alt='' src={repo_icons_link("icon-forfait.png")} />
                                        </div>
                                        <div className='text-end ms-2 me-3'>
                                            <div className='d-flex justify-content-between align-items-center'>
                                                <h6 className="me-4">Forfaits</h6>
                                                <h2 className='fs-3'>
                                                    {n_forfaits_total_year !== undefined && n_forfaits_total_year !== null ? n_forfaits_total_year : '0' }
                                                </h2>
                                            </div>
                                            <h6>
                                                Utilizados: {n_forfaits_year !== undefined && n_forfaits_year !== null ? n_forfaits_year : '0' }
                                            </h6>
                                            <h6>{language[lang].dash_stats_year}</h6>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className={`dash-cards-2 highlights highlights-sm`}>
                            <div className={"card-single"}>
                                <div className="card-body">
                                    <div className='d-flex justify-content-between align-items-center' >
                                        <div className='d-flex justify-content-between align-items-center' style={{height: '52px'}}>
                                            <img className="img-fluid" style={{maxHeight: '35px'}} alt='' src={repo_icons_link("icon-equipamento.png")} />
                                        </div>
                                        <div className='text-end ms-2 me-3'>
                                            <div className='d-flex justify-content-between align-items-center'>
                                                <h6 className="me-4">Equipamentos</h6>
                                                <h2 className='fs-3'>
                                                    {n_equipments_total_day !== undefined && n_equipments_total_day !== null ? n_equipments_total_day : '0' }
                                                </h2>
                                            </div>
                                            <h6>
                                                Utilizados: {n_equipments_day !== undefined && n_equipments_day !== null ? n_equipments_day : '0' }
                                            </h6>
                                            <h6>{language[lang].dash_stats_day}</h6>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className={"card-single"}>
                                <div className="card-body">
                                    <div className='d-flex justify-content-between align-items-center' >
                                        <div className='d-flex justify-content-between align-items-center' style={{height: '52px'}}>
                                            <img className="img-fluid" style={{maxHeight: '35px'}} alt='' src={repo_icons_link("icon-equipamento.png")} />
                                        </div>
                                        <div className='text-end ms-2 me-3'>
                                            <div className='d-flex justify-content-between align-items-center'>
                                                <h6 className="me-4">Equipamentos</h6>
                                                <h2 className='fs-3'>
                                                    {n_equipments_total_last !== undefined && n_equipments_total_last !== null ? n_equipments_total_last : '0' }
                                                </h2>
                                            </div>
                                            <h6>
                                                Utilizados: {n_equipments_last !== undefined && n_equipments_last !== null ? n_equipments_last : '0' }
                                            </h6>
                                            <h6>{language[lang].dash_stats_last}</h6>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className={"card-single"}>
                                <div className="card-body">
                                    <div className='d-flex justify-content-between align-items-center' >
                                        <div className='d-flex justify-content-between align-items-center' style={{height: '52px'}}>
                                            <img className="img-fluid" style={{maxHeight: '35px'}} alt='' src={repo_icons_link("icon-equipamento.png")} />
                                        </div>
                                        <div className='text-end ms-2 me-3'>
                                            <div className='d-flex justify-content-between align-items-center'>
                                                <h6 className="me-4">Equipamentos</h6>
                                                <h2 className='fs-3'>
                                                    {n_equipments_total_month !== undefined && n_equipments_total_month !== null ? n_equipments_total_month : '0' }
                                                </h2>
                                            </div>
                                            <h6>
                                                Utilizados: {n_equipments_month !== undefined && n_equipments_month !== null ? n_equipments_month : '0' }
                                            </h6>
                                            <h6>{language[lang].dash_stats_month}</h6>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className={"card-single"}>
                                <div className="card-body">
                                    <div className='d-flex justify-content-between align-items-center' >
                                        <div className='d-flex justify-content-between align-items-center' style={{height: '52px'}}>
                                            <img className="img-fluid" style={{maxHeight: '35px'}} alt='' src={repo_icons_link("icon-equipamento.png")} />
                                        </div>
                                        <div className='text-end ms-2 me-3'>
                                            <div className='d-flex justify-content-between align-items-center'>
                                                <h6 className="me-4">Equipamentos</h6>
                                                <h2 className='fs-3'>
                                                    {n_equipments_total_year !== undefined && n_equipments_total_year !== null ? n_equipments_total_year : '0' }
                                                </h2>
                                            </div>
                                            <h6>
                                                Utilizados: {n_equipments_year !== undefined && n_equipments_year !== null ? n_equipments_year : '0' }
                                            </h6>
                                            <h6>{language[lang].dash_stats_year}</h6>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className={`dash-cards body`}>
                            <div className="container">
                                <div className="card mt-3 mb-5 mb-xl-8 d-none">
                                    <div className="card-body">
                                    
                                        <div className="pb-10">
                                            <div className="div-table">
                                                <div className="table-body">
                                                    <DataTableExtensions {...tableDataPO}>
                                                        <DataTable
                                                            noDataComponent={language[lang].table_empty}
                                                            noHeader
                                                            pagination
                                                            exportHeaders
                                                            paginationComponentOptions={defaultComponentOptions}
                                                            paginationPerPage={50}
                                                            paginationRowsPerPageOptions={[50, 100, 150]}
                                                        />
                                                    </DataTableExtensions>
                                                </div>
                                            </div>
                                        </div>
                    
                                    </div>
                                </div>

                                <div className="card mt-3 mb-5 mb-xl-8">
                                    <div className="card-body">
                                    
                                        <div className="pb-10">
                                            <div className="div-table">
                                                <label className="col-form-label fw-bold fs-4 pt-3 ps-3">Lista de Encomendas</label>
                                                
                                                <div className="table-body">
                                                    <DataTable
                                                        title=""
                                                        columns={columns_po}
                                                        data={list_purchase_orders}
                                                        pagination
                                                        highlightOnHover
                                                    />
                                                </div>
                                            </div>
                                        </div>
                    
                                    </div>
                                </div>
                            </div>
                        </div>

                        {
                        false ?
                            <div className={`dash-cards body`}>
                                <div className="container">
                                    <div className="card mt-3 mb-5 mb-xl-8">
                                        <div className="card-body">
                                        
                                            <div className="pb-10">
                                                <div className="div-table">
                                                    <label className="col-form-label fw-bold fs-4 pt-3 ps-3">Lista de Equipamento por entregar</label>
                                                    
                                                    <div className="table-body">
                                                        {
                                                        isloadingEquipment ?
                                                            <div className="d-flex justify-content-center p-5">
                                                                <div className="spinner-border" role="status">
                                                                <span className="visually-hidden">Loading...</span>
                                                                </div>
                                                            </div>
                                                        :
                                                            <DataTable
                                                                title=""
                                                                columns={columns_eq}
                                                                data={list_equipments}
                                                                pagination
                                                                highlightOnHover
                                                            />
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                        
                                        </div>
                                    </div>
                                </div>
                            </div>
                        :
                            null
                        }
                    </>
                :
                    null
                }
                {
                getTokenInfo().profile === 'Colaborador' || getTokenInfo().profile === 'Instrutor' ?
                    <>
                        <div className={`dash-cards-2 header`}>
                            <h2 className="dash-title">{language[lang].dashboard}</h2>
                            <p>{language[lang].dashboard}</p>
                        </div>

                        <div className={`dash-cards body`}>
                            <div className="container">

                                <div className="card mt-3 mb-5 mb-xl-8">
                                    <div className="card-body">
                                    
                                        <div className="pb-10">
                                            <div className="div-table">
                                                <label className="col-form-label fw-bold fs-4 pt-3 ps-3">Lista de Encomendas</label>
                                                
                                                <div className="table-body">
                                                    <DataTable
                                                        title=""
                                                        columns={columns_po_colaboradores}
                                                        data={list_purchase_orders}
                                                        pagination
                                                        highlightOnHover
                                                    />
                                                </div>
                                            </div>
                                        </div>
                    
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                :
                    null
                }
            </main>
    )
}
